module.exports = __webpack_public_path__ + "media/images/icons-retina-6756543229b2d83cf7c8b1263c0e6b4c.png";